const utils = require('../../../lib/utils')

module.exports = {
    extends: [
        '/',
        'base',
        'bootstrap5',
        'form',
        'relationship',
    ],

    model: {
        keyDownLabelAttributesByResourceKey: {},
        keyDownLabelElementHeadOptionsByResourceKey: {},
    },

    methods: {
        updateKeyDownLabelValue: function(fieldCode, fieldConfig, value, callerFormFieldComponent) {
            callerFormFieldComponent.closest('base_accordion_element', element => {
                const config = element.config || {}
                const registerSecret = config.registerSecret
                const separatorResourceIndex = (config.separator || {}).resourceIndex
                if(registerSecret !== undefined && separatorResourceIndex !== undefined) {
                    element.closest('base_accordion_accordion', accordion => {
                        this.model.keyDownLabelAttributesByResourceKey[separatorResourceIndex] = this.model.keyDownLabelAttributesByResourceKey[separatorResourceIndex] || {}
                        this.model.keyDownLabelElementHeadOptionsByResourceKey[separatorResourceIndex] = this.model.keyDownLabelElementHeadOptionsByResourceKey[separatorResourceIndex] || {}

                        this.model.keyDownLabelAttributesByResourceKey[separatorResourceIndex][fieldCode] = value
                        this.updateRelationshipElement(this.model.keyDownLabelElementHeadOptionsByResourceKey[separatorResourceIndex], undefined, separatorResourceIndex)
                        accordion.refreshElement(registerSecret, {
                            title: this.model.keyDownLabelElementHeadOptionsByResourceKey[separatorResourceIndex].title
                        });
                    });
                }
            })
        },

        updateRelationshipElement(refElementHeadOptions, resourceData, resourceKey){
            refElementHeadOptions = refElementHeadOptions || {}
            resourceData = resourceData || {}
            if(resourceKey === undefined) resourceKey = 'UNIDENTIFIED_RESOURCE';

            const data = (resourceData || {}).data || {}
            let attributes = this.model.keyDownLabelAttributesByResourceKey[resourceKey] || {}
            delete attributes.dataIndex
            if(utils.isEmpty(attributes) && !utils.isEmpty(data.attributes)){
                attributes = this.model.keyDownLabelAttributesByResourceKey[resourceKey] = data.attributes
            }
            this.model.keyDownLabelElementHeadOptionsByResourceKey[resourceKey] = refElementHeadOptions || {}

            const nameParts = []
            if(attributes.firstname)    nameParts.push(attributes.firstname);
            if(attributes.lastname)     nameParts.push(attributes.lastname);

            refElementHeadOptions.title = nameParts.join(' ')
            refElementHeadOptions.icon = refElementHeadOptions.icon || 'fi fi-participant'

            if(!refElementHeadOptions.buttons){
                refElementHeadOptions.buttons = [{
                    buttonType: 'delete',
                    context:    'participant',
                    neutral:    true,
                    forceTag:   'a'
                }]
            }
        },

        delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
            const { registerSecret } = (additionalData || {})

            if(registerSecret !== undefined){
                this.find('base_accordion_accordion', accordion => {
                    const elementContentComponent = accordion.getElementContentComponent(registerSecret)
                    if(elementContentComponent){

                        const primaryKey = elementContentComponent.getFieldValue('primaryKey')
                        if(primaryKey){
                            elementContentComponent.model.dirtyFields.data.type = 'delete'
                            elementContentComponent.fieldToModel('primaryKey')
                            const element = accordion.getElement(registerSecret)
                            element.mark('readyToDelete', true)
                            element.deactivate()
                        } else {
                            // elementContentComponent.model.dirtyFields.data.type = 'keepNull'
                            elementContentComponent.model.dirtyFields.data.attributes = {}
                            // this is necessary to tell all parent forms that the participant dirties has been set to an empty object.
                            elementContentComponent.fieldToModel('primaryKey')
                            accordion.removeElement(registerSecret)
                        }
                    }
                })
            }
        }
    }
}
